import PropTypes from 'prop-types';
import CatalogBrowser from '@/components/catalog/CatalogBrowser';
import SeoHead from '@/components/SeoHead';
import { fetchProductsAdmin } from '@/lib/firebaseAdmin';
import { productPropType } from '@/lib/propTypes';
import { buildCatalogHierarchy, buildCatalogPath } from '@/lib/productRoutes';

export default function DepartmentCatalogPage({ products = [], department }) {
  const departmentDescription = department.subcategories?.length
    ? `Browse the ${department.name} department, move through its subdivisions, and narrow down to the pair you want.`
    : `Browse every available item in the ${department.name} department and open the exact product page you need.`;

  return (
    <main className="space-y-10 px-4 py-10 md:px-6">
      <SeoHead
        title={`${department.name} | Trendy Quest Collection Kenya`}
        description={departmentDescription}
        path={buildCatalogPath({ department: department.name })}
      />
      <CatalogBrowser products={products} selectedDepartmentSlug={department.slug} />
    </main>
  );
}

DepartmentCatalogPage.propTypes = {
  products: PropTypes.arrayOf(productPropType),
  department: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export async function getStaticPaths() {
  const hierarchy = buildCatalogHierarchy(await fetchProductsAdmin());

  return {
    paths: hierarchy.map((department) => ({
      params: { department: department.slug },
    })),
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params }) {
  const products = await fetchProductsAdmin();
  const hierarchy = buildCatalogHierarchy(products);
  const department = hierarchy.find((entry) => entry.slug === params?.department) || null;

  if (!department) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }

  return {
    props: {
      products,
      department,
    },
    revalidate: 60,
  };
}
